'use client'
import { useEffect, useRef, useState } from 'react'
import Script from 'next/script'

export default function AdBanner() {
    const ref = useRef<HTMLDivElement | null>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!ref.current) return;
        let io: IntersectionObserver | null = null;
        try {
            io = new IntersectionObserver((entries) => {
                for (const e of entries) {
                    if (e.isIntersecting) {
                        setVisible(true);
                        if (io) {
                            io.disconnect();
                            io = null;
                        }
                        break;
                    }
                }
            }, { root: null, threshold: 0.01 });
            io.observe(ref.current);
        } catch (err) {
            // Fallback: make visible after a short delay
            const t = window.setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(t);
        }

        return () => {
            if (io) io.disconnect();
        };
    }, []);

    useEffect(() => {
        if (!visible) return;
        try {
            // Initialize ads after script loads and ad became visible
            // @ts-ignore
            (window.adsbygoogle = window.adsbygoogle || []).push({})
        } catch (e) { }
    }, [visible])

    return (
        <div ref={ref}>
            {visible && (
                <>
                    <Script
                        strategy="lazyOnload"
                        src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9683377665713531`}
                        crossOrigin="anonymous"
                    />
                    <ins className="adsbygoogle"
                        style={{ display: 'block' } as React.CSSProperties}
                        data-ad-client="ca-pub-9683377665713531"
                        data-ad-slot="7080224338"
                        data-ad-format="auto"
                        data-full-width-responsive="true">
                    </ins>
                </>
            )}
        </div>
    )
}
